import {
  ReportType,
  ScoringForDirectReportsResponse,
  SettingsPeriod,
  DirectReportScoringData
} from "@/entities/reporting/types";
import { UserData } from "@/entities/users/types";
import { ScoringTableDataRow } from "@/components/controls/DataTable/ScoringTable";
import { createScoringTableContext } from "@/components/layouts/ScoringTableCard/BaseScoringTableContext";

const { ScoringTableProvider } = createScoringTableContext();

const transformChampionsResponse = (
  data: ScoringForDirectReportsResponse
): ScoringTableDataRow[] => {
  const championsData = data.championsMappingScore?.data
    .directReports as DirectReportScoringData[];
  if (!championsData) return [];

  return championsData.map((scoringData: DirectReportScoringData) => ({
    user: { id: scoringData.id } as UserData,
    summaryValue: scoringData.avgScore,
    scoreIndicator: [scoringData.directReportsNum, scoringData.weakDealsNum, 0]
  }));
};

export const ChampionsScoringProvider: React.FC<{
  children: React.ReactNode;
  leadUser: UserData | undefined;
  period?: SettingsPeriod;
}> = ({ children, leadUser, period }) => (
  <ScoringTableProvider
    leadUser={leadUser}
    period={period}
    reportType={ReportType.CHAMPION_MAPPING_SCORE}
    transformResponse={transformChampionsResponse}
  >
    {children}
  </ScoringTableProvider>
);
